module.exports = __webpack_public_path__ + "img/kk.e93f09d5.svg";